module.exports = __webpack_public_path__ + "img/intelligent4.1715efe6.png";